import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Layouts.css";
import {
  getCompleteData,
  getItems,
  getYears,
  searchPart,
} from "../../../actions/HomeAction";
import Axios from "../../../axios/axios";
import { toast } from "react-toastify";
import Spinner from "../../Loader/Spinner";
import Select from "react-select";

const Middle = ({ initialFilters = {} }) => {
  const [spareModels, setSpareModels] = useState([]);
  const [spareBrand, setSpareBrand] = useState([]);
  const [spareCategory, setSpareCategory] = useState([]);
  const [region, setRegion] = useState([]);
  const [years, setYears] = useState([]);

  const [selectedBrand, setSelectedBrand] = useState(
    initialFilters.brandId || ""
  );
  const [selectedModel, setSelectedModel] = useState(
    initialFilters.modelId || ""
  );
  const [selectedYear, setSelectedYear] = useState(initialFilters.year || "");
  const [selectedRegion, setSelectedRegion] = useState(
    initialFilters.regionId || ""
  );

  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  // Fetch initial data
  useEffect(() => {
    getCompleteData(setSpareModels, setSpareBrand, setSpareCategory);
    getItems(setRegion);
    setYears(getYears());
    getModelData(initialFilters.brandId || "");
  }, []);

  // Fetch models for selected brand
  const getModelData = async (brandId = selectedBrand) => {
    if (!brandId) {
      setSpareModels([]);
      setSelectedModel(""); // reset model if brand cleared
      return;
    }
    try {
      const res = await Axios.post("/model/modelBybrand", { brand: brandId });
      setSpareModels(res.data);

      // Set model if initialFilters.modelId exists in new models
      if (initialFilters.modelId) {
        const exists = res.data.some((m) => m._id === initialFilters.modelId);
        if (exists) setSelectedModel(initialFilters.modelId);
      }
    } catch (error) {
      console.error(error);
      setSpareModels([]);
    }
  };

  const sectionStyle = {
    backgroundSize: "cover",
    backgroundPosition: "center",
  };

  const handleSearch = async () => {
    const filters = {};
    if (selectedBrand) filters.brandId = selectedBrand;
    if (selectedModel) filters.modelId = selectedModel;
    if (selectedYear) filters.year = selectedYear;
    if (selectedRegion) filters.regionId = selectedRegion;

    if (Object.keys(filters).length === 0) {
      toast.warning("Please select at least one filter.", {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    setLoading(true);

    try {
      const parts = await searchPart(filters);
      const searchParams = new URLSearchParams(filters).toString();
      navigate(`/category?${searchParams}`, {
        state: {
          spareCategory,
          spareBrand,
          spareModels,
          region,
          years,
        },
      });
      setLoading(false);
    } catch (error) {
      console.error("Error fetching parts:", error);
      alert("An error occurred while fetching parts. Please try again.");
    }
  };

  const style = {
    fontFamily: "Poppins', sans-serif",
    position: "relative",
    fontWeight: 1000,
    color: "#353C4B",
    fontSize: "104px !important",
  };

  console.log(spareBrand, "spareBrandspareBrandspareBrand");

  const customStyles = {
    control: (base, state) => ({
      ...base,
      height: 50,
      minHeight: 50,
      borderRadius: 6,
      borderColor: "#ccc",
      backgroundColor: "#fff",
      paddingLeft: 4,
      fontFamily: "Poppins, sans-serif",
      fontSize: 15,
      boxShadow: state.isFocused ? "0 0 0 2px rgba(30,99,216,0.2)" : "none",
      "&:hover": { borderColor: "#ccc" },
    }),

    menu: (base) => ({
      ...base,
      marginTop: 2,
      borderRadius: 6,
      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      zIndex: 99999,
      backgroundColor: "#fff",
      position: "absolute",
    }),

    menuList: (base) => ({
      ...base,
      paddingTop: 0,
      paddingBottom: 0,
      maxHeight: 200,
    }),

    option: (base, state) => ({
      ...base,
      padding: "10px 12px",
      fontSize: 15,
      backgroundColor: state.isSelected
        ? "#efefef"
        : state.isFocused
        ? "#f3f4f6"
        : "#ffffff",
      color: "#374151",
      cursor: "pointer",
    }),

    placeholder: (base) => ({
      ...base,
      color: "#374151",
    }),

    dropdownIndicator: (base) => ({
      ...base,
      color: "#6b7280",
      paddingRight: 12,
    }),

    indicatorSeparator: () => ({
      display: "none",
    }),

    valueContainer: (base) => ({
      ...base,
      paddingLeft: 4,
    }),

    // This is crucial for proper z-index handling
    menuPortal: (base) => ({
      ...base,
      zIndex: 99999,
    }),
  };

  return (
    <div className="Middle-Container">
      <div className="Middle-Content">
        {/* Heading Section */}
        <div className="Middle-Heading-Section">
          <h1 className="Middle-Title">FIND PART BY VEHICLE</h1>
          <p className="Middle-Description">
            From its medieval origins to the digital era, learn everything there
            is to know about the ubiquitous lorem ipsum passage.
          </p>
        </div>

        {/* Search Form */}
        <div className="Middle-Search-Form">
          <div className="Middle-Select-Wrapper">
            <Select
              options={spareBrand}
              value={spareBrand.find((b) => b.value === selectedBrand) || null}
              onChange={(selectedOption) => {
                const brandId = selectedOption ? selectedOption.value : "";
                setSelectedBrand(brandId);
                getModelData(brandId);
              }}
              placeholder="Select Brand"
              styles={customStyles}
              isSearchable
              menuPortalTarget={document.body}
              menuPosition="fixed"
            />
          </div>

          {/* Model */}
          <div className="Middle-Select-Wrapper">
            <Select
              options={spareModels.map((m) => ({
                value: m._id,
                label: m.name,
              }))}
              value={
                spareModels
                  .map((m) => ({ value: m._id, label: m.name }))
                  .find((m) => m.value === selectedModel) || null
              }
              onChange={(selectedOption) =>
                setSelectedModel(selectedOption ? selectedOption.value : "")
              }
              placeholder="Select Model"
              styles={customStyles}
              isSearchable
              menuPortalTarget={document.body}
              menuPosition="fixed"
            />
          </div>

          {/* Year */}
          <div className="Middle-Select-Wrapper">
            <Select
              options={years.map((y) => ({ value: y, label: y }))}
              value={
                years
                  .map((y) => ({ value: y, label: y }))
                  .find((y) => y.value === selectedYear) || null
              }
              onChange={(selectedOption) =>
                setSelectedYear(selectedOption ? selectedOption.value : "")
              }
              placeholder="Select Year"
              styles={customStyles}
              isSearchable
              menuPortalTarget={document.body}
              menuPosition="fixed"
            />
          </div>

          {/* Region */}
          <div className="Middle-Select-Wrapper">
            <Select
              options={region.map((r) => ({ value: r._id, label: r.name }))}
              value={
                region
                  .map((r) => ({ value: r._id, label: r.name }))
                  .find((r) => r.value === selectedRegion) || null
              }
              onChange={(selectedOption) =>
                setSelectedRegion(selectedOption ? selectedOption.value : "")
              }
              placeholder="Select Region"
              styles={customStyles}
              isSearchable
              menuPortalTarget={document.body}
              menuPosition="fixed"
            />
          </div>

          {/* Search Button */}
          <div className="Middle-Button-Wrapper">
            <button onClick={handleSearch} className="Middle-Search-Button">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="Middle-Search-Icon"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
              Search
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Middle;
